import script from "./PlayerListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayerListItem.vue?vue&type=script&setup=true&lang=js"

import "./PlayerListItem.vue?vue&type=style&index=0&id=0ba8fe79&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ba8fe79"]])

export default __exports__